import type { CSSProperties } from "react";
import { Link } from "react-router-dom";

const wrap: CSSProperties = {
  minHeight: "var(--vh-full)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "var(--sz-space-7)",
  background: "var(--sz-bg-base)",
  textAlign: "center",
};

const code: CSSProperties = {
  fontFamily: "var(--sz-font-display)",
  fontSize: "var(--sz-display-md)",
  letterSpacing: "4px",
  color: "var(--sz-amber-text)",
  marginBottom: "var(--sz-space-3)",
  lineHeight: 1,
};

const title: CSSProperties = {
  fontFamily: "var(--sz-font-head)",
  fontSize: "var(--sz-head-md)",
  color: "var(--sz-text-primary)",
  marginBottom: "var(--sz-space-3)",
};

const back: CSSProperties = {
  fontFamily: "var(--sz-font-body)",
  fontSize: "var(--sz-body-sm)",
  color: "var(--sz-amber-text)",
};

export function NotFoundPage(): JSX.Element {
  return (
    <div style={wrap}>
      <div>
        <div style={code}>404</div>
        <h1 style={title}>Off the map.</h1>
        <Link to="/dashboard" style={back}>
          ← Back to dashboard
        </Link>
      </div>
    </div>
  );
}
